/*
  Utility Class for time functions
*/
class TimeUtil {
  /**
   * get a time code for countdowns etc.
   * @param {number} time time in millisconds
   */
  static getTimeCode(time) {
    const duration = new Date(time);
    let timeString = `${TimeUtil.formatTimeToTwoDigit(duration.getUTCHours())}:`;
    timeString += `${TimeUtil.formatTimeToTwoDigit(duration.getUTCMinutes())}:`;
    timeString += TimeUtil.formatTimeToTwoDigit(duration.getUTCSeconds());
    return timeString;
  }

  /**
   * Add the leading 0 if time is too short
   * @param {number}
   * @returns {string}
   */
  static formatTimeToTwoDigit(time) {
    if (time.toString().length === 1) {
      return `0${time}`;
    }
    return time.toString();
  }

  /**
   * get days since date time
   * @param {Date} date
   */
  static getDaysSinceDate(date) {
    const startTime = date.getTime();
    const deltaTime = Date.now() - startTime;
    const oneDay = 24 * 60 * 60 * 1000;
    const diff = Math.floor(deltaTime / oneDay);
    return diff;
  }
}

window.TimeUtil = TimeUtil;
